(function(){function patch(){document.querySelectorAll('.jsq-home-v2 .product-img img').forEach(function(img){img.style.objectFit='contain';img.style.padding='10px';img.style.background='#fffaf2';});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',patch);else patch();})();

/* PREDICTIVE-FIX 2026-05-27 — inline predictive autocomplete for the mobile app-bar
   open search field. The 2026-05-25 app-bar redesign (snippets/mobile-app-bar.liquid)
   replaced the search-ICON button (which opened the full-screen mobile-search-overlay)
   with an open <form class="js-app-bar__search">, but left it as a plain GET form with
   NO suggestions — so typing showed no dropdown. This self-contained injector adds an
   inline dropdown under that field, reusing the same /search/suggest.json contract as
   snippets/mobile-search-overlay.liquid. It lives in this already-loaded asset so the
   large mobile-app-bar.liquid snippet does not have to be rewritten. */
(function(){
  function init(){
    var form = document.querySelector('.js-app-bar__search');
    if(!form || form.getAttribute('data-predict-wired')) return;
    var input = form.querySelector('input[type="search"]');
    if(!input) return;
    form.setAttribute('data-predict-wired','1');

    if(!document.getElementById('js-appbar-predict-css')){
      var css = document.createElement('style');
      css.id = 'js-appbar-predict-css';
      css.textContent = [
        '.js-app-bar__search-wrap{position:relative;}',
        '.js-appbar-results{position:absolute;top:calc(100% - 3px);left:12px;right:12px;z-index:250;background:#fffdf8;border:1px solid #efe5cf;border-radius:14px;box-shadow:0 14px 30px rgba(0,0,0,.18);max-height:min(70vh,460px);overflow-y:auto;-webkit-overflow-scrolling:touch;padding:4px 0 6px;}',
        '.js-appbar-results[hidden]{display:none;}',
        '.js-appbar-results .sec{padding:12px 16px 4px;font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:.16em;color:#b89455;margin:0;}',
        '.js-appbar-results .row{display:flex;gap:12px;align-items:center;padding:9px 16px;text-decoration:none;color:#1a120b;-webkit-tap-highlight-color:rgba(184,148,85,.15);}',
        '.js-appbar-results .row:active{background:#fbf3e2;}',
        '.js-appbar-results .row img,.js-appbar-results .row .ph{width:44px;height:44px;min-width:44px;border-radius:8px;object-fit:cover;background:#fbf3e2;flex:0 0 auto;display:grid;place-items:center;font-size:18px;}',
        '.js-appbar-results .row .b{flex:1;min-width:0;}',
        '.js-appbar-results .row .t{font-size:14px;font-weight:500;margin:0 0 2px;line-height:1.3;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}',
        '.js-appbar-results .row .m{font-size:12px;color:#5a4f43;margin:0;display:flex;gap:8px;align-items:baseline;}',
        '.js-appbar-results .row .m strong{color:#1a120b;font-weight:600;}',
        '.js-appbar-results .all{display:block;padding:12px 16px;border-top:1px solid #efe5cf;margin-top:4px;font-size:14px;font-weight:600;color:#8b3a4a;text-decoration:none;text-align:center;}',
        '.js-appbar-results .none{padding:18px 16px;text-align:center;color:#5a4f43;font-size:14px;}',
        '.js-appbar-results .none a{color:#8b3a4a;text-decoration:underline;}'
      ].join('');
      document.head.appendChild(css);
    }

    var wrap = document.createElement('div');
    wrap.className = 'js-app-bar__search-wrap';
    form.parentNode.insertBefore(wrap, form);
    wrap.appendChild(form);
    var panel = document.createElement('div');
    panel.className = 'js-appbar-results';
    panel.setAttribute('role','listbox');
    panel.hidden = true;
    wrap.appendChild(panel);
    input.setAttribute('autocomplete','off');
    input.setAttribute('aria-expanded','false');

    var t = null, ac = null;
    function esc(s){return String(s).replace(/[&<>"']/g,function(m){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m];});}
    function hide(){panel.hidden=true;panel.innerHTML='';input.setAttribute('aria-expanded','false');}
    function show(){panel.hidden=false;input.setAttribute('aria-expanded','true');}

    function render(q,data){
      var r=(data&&data.resources&&data.resources.results)||{};
      var products=r.products||[],collections=r.collections||[];
      if(!products.length&&!collections.length){
        panel.innerHTML='<p class="none">No matches for &ldquo;'+esc(q)+'&rdquo;.<br><a href="/search?q='+encodeURIComponent(q)+'">Open full search →</a></p>';
        show();return;
      }
      var html='';
      if(products.length){
        html+='<p class="sec">Products</p>';
        products.forEach(function(p){
          html+='<a class="row" href="'+esc(p.url||'#')+'">'+
            (p.image?'<img src="'+esc(p.image)+'" alt="" loading="lazy">':'<span class="ph">📕</span>')+
            '<span class="b"><p class="t">'+esc(p.title||'')+'</p><p class="m">'+
            (p.vendor?'<span>'+esc(p.vendor)+'</span>':'')+
            (p.price?'<strong>'+esc(p.price)+'</strong>':'')+
            '</p></span></a>';
        });
      }
      if(collections.length){
        html+='<p class="sec">Collections</p>';
        collections.forEach(function(c){
          html+='<a class="row" href="'+esc(c.url||'#')+'"><span class="ph">📂</span><span class="b"><p class="t">'+esc(c.title||'')+'</p></span></a>';
        });
      }
      html+='<a class="all" href="/search?q='+encodeURIComponent(q)+'">See all results for &ldquo;'+esc(q)+'&rdquo; →</a>';
      panel.innerHTML=html;show();
    }

    function run(q){
      if(ac){try{ac.abort();}catch(e){}}
      ac=new AbortController();
      var url='/search/suggest.json?q='+encodeURIComponent(q)+
        '&resources%5Btype%5D=product%2Ccollection'+
        '&resources%5Blimit%5D=6'+
        '&resources%5Boptions%5D%5Bunavailable_products%5D=last'+
        '&resources%5Boptions%5D%5Bfields%5D=title%2Cvendor%2Cproduct_type%2Cvariants.title%2Cvariants.sku%2Cbody';
      fetch(url,{signal:ac.signal,headers:{'Accept':'application/json'}})
        .then(function(r){return r.json();})
        .then(function(data){render(q,data);})
        .catch(function(err){if(err&&err.name==='AbortError')return;hide();});
    }

    input.addEventListener('input',function(){
      var q=this.value.trim();if(/^(?:24[\s\-\/]*(?:6|six)|twenty\s+four\s+six)(?:\s+player)?$/i.test(q))q='24Six';
      clearTimeout(t);
      if(q.length<2){hide();return;}
      t=setTimeout(function(){run(q);},180);
    });
    input.addEventListener('focus',function(){
      if(this.value.trim().length>=2&&panel.innerHTML)show();
    });
    document.addEventListener('click',function(e){
      if(!wrap.contains(e.target))hide();
    });
    input.addEventListener('keydown',function(e){
      if(e.key==='Escape'){hide();this.blur();}
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);
  else init();
})();

/* ==== SPRINT2.1 reveal-on-scroll (2026-07-04) ====
   Sections/cards fade+rise 12px with a 40ms stagger as they enter the
   viewport. JS adds .jsq-reveal so no-JS visitors see everything; skips
   entirely under prefers-reduced-motion or without IntersectionObserver. */
(function(){
  function initReveal(){
    if(!('IntersectionObserver' in window))return;
    if(window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    var els=document.querySelectorAll('.jsq-cg__grid > *, .jsq-tiles__grid > *, .js-footer__cols > *');
    if(!els.length)return;
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){
        if(e.isIntersecting){e.target.classList.add('is-inview');io.unobserve(e.target);}
      });
    },{rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(el,i){
      var r=el.getBoundingClientRect();
      if(r.top<window.innerHeight&&r.bottom>0){return;} /* already on screen: never hide first paint */
      el.style.setProperty('--stagger',(i%6)*40+'ms');
      el.classList.add('jsq-reveal');
      io.observe(el);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initReveal);
  else initReveal();
})();
